export const CONSULTATIONS = 'fo/consultations/page'
export const CONSULTATION = 'fo/consultations/edit'
export const UPDATE_CONSULTATION = 'fo/consultations/update'
export const DELETE_CONSULTATION = 'fo/consultations/delete'
export const SET_CONSULTATIONS_ORDER = 'fo/consultations/setOrder'
export const SET_CONSULTATIONS_DESCASC = 'fo/consultations/setDescAsc'
export const SET_CONSULTATIONS_FILTERS = 'fo/consultations/setFilters'
export const RESET_CONSULTATIONS_FILTERS = 'fo/consultations/resetFilters'
